var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBigCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.66,23.21l-8.62-8.62-1.41-.59H11l-1.41,.59L.96,23.21l-.59,1.41v51.75l.59,1.41,8.62,8.62,1.41,.59H88.62l1.41-.59,8.62-8.62,.59-1.41V24.62l-.59-1.41ZM11.83,18H87.8l7.45,7.45v7.8H4.38v-7.8l7.45-7.45ZM87.8,83H11.83l-7.45-7.45v-29.36H95.25v29.36l-7.45,7.45ZM15.31,63.44h25.88v8.62H15.31v-8.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigCreditcard);
export default __webpack_public_path__ + "static/1765206080/media/icon-big-creditcard.004cb44955ab96360a688cf45b9f5df0.svg";
export { ForwardRef as ReactComponent };